import { useTranslation } from 'react-i18next';
import { useSettings } from 'settings';

import { MutableRefObject, useEffect, useMemo, useState } from 'react';
import { ActionFooter } from 'navigation';
import { CSSInterpolation } from '@nuvo-importer/common';

type ReviewEntriesActionFooterProps = {
  onPositiveClick?: () => void;
  onNegativeClick?: () => void;
  positiveButtonText?: string;
  disabledPositive?: boolean;
  className?: string;
  errorCount?: MutableRefObject<number>;
  popoverInfoTheme: CSSInterpolation;
};

const ReviewEntriesActionFooter = ({
  onPositiveClick,
  onNegativeClick,
  positiveButtonText,
  disabledPositive = false,
  className,
  errorCount = { current: 0 },
  popoverInfoTheme,
}: ReviewEntriesActionFooterProps) => {
  const { t } = useTranslation();
  const { completeImportAction } = useSettings();
  const [errorNumber, setErrorNumber] = useState(0);

  useEffect(() => {
    if (completeImportAction === 'block') {
      const interval = setInterval(() => {
        setErrorNumber(errorCount.current);
      }, 150);

      return () => {
        clearTimeout(interval);
      };
    }
    return;
  }, [errorCount, completeImportAction]);

  const disabledPositiveButton = useMemo(() => errorNumber > 0, [errorNumber]);

  const disabledSubmitButton = useMemo(
    () => completeImportAction === 'block' && disabledPositiveButton,
    [completeImportAction, disabledPositiveButton]
  );

  return (
    <ActionFooter
      footerStyle="px-8"
      className={className}
      positiveButtonText={positiveButtonText}
      disabledPositive={disabledPositive}
      onPositiveClick={onPositiveClick}
      onNegativeClick={onNegativeClick}
      enablePopper={disabledSubmitButton}
      popperMessage={t(
        errorNumber === 1
          ? 'txt_invalid_data_behavior_block'
          : 'txt_invalid_data_behavior_block_more_error',
        {
          errorCount: errorNumber,
        }
      )}
      positiveButtonClassName={
        disabledSubmitButton ? 'cursor-not-allowed opacity-70' : ''
      }
      popoverInfoTheme={popoverInfoTheme}
    />
  );
};

export default ReviewEntriesActionFooter;
